<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="info"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="轮播图位置">
        <el-select
          class="search-el"
          v-model="info.banner_item_id"
          placeholder="请选择"
          clearable
          @change="changeBannerItem()"
        >
          <el-option
            v-for="value,key in bannerItemList"
            :key="key"
            :label="value"
            :value="key"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="显示平台" v-show="this.info.banner_item_id != 46 && this.info.banner_item_id != 47 && this.info.banner_item_id != 48">
        <el-select
            class="search-el"
            size="mini"
            v-model="info.target_client"
            placeholder="请选择"
            clearable
            filterable
            :disabled="targetClientAble"
        >
          <el-option label="全部" value="ALL">全部</el-option>
          <el-option label="灵动生活app" value="APP">灵动生活app</el-option>
          <el-option label="灵动生活h5" value="H5">灵动生活h5</el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="标题" prop="title">
        <el-input
          v-model="info.title"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img v-if="info.image" :src="info.image" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip" v-show="[1,2,3,4,5,6,8,10,12,13,14,16,17,18].indexOf(Number(info.banner_item_id)) >= 0">
            只能上传jpg/png文件，顶部轮播图尺寸690*290px， 推荐位690*170px，大小不超过100K
          </div>
          <div slot="tip" class="el-upload__tip" v-show="info.banner_item_id == 11">
            只能上传jpg/png文件，APP android 开屏图片1：1080*1920px 大小不超过200K
          </div>
          <div slot="tip" class="el-upload__tip" v-show="info.banner_item_id == 15">
            只能上传jpg/png文件，尺寸750*400px， 大小不超过100K
          </div>
          <div slot="tip" class="el-upload__tip" v-show="info.banner_item_id == 25">
            只能上传jpg/png文件，尺寸702*140px， 大小不超过100K
          </div>
          <div slot="tip" class="el-upload__tip" v-show="info.banner_item_id == 19">
            只能上传jpg/png文件，建议研习社轮播图尺寸：674*244px，大小不超过100K
          </div>
          <div slot="tip" class="el-upload__tip" v-show="info.banner_item_id == 20">
            只能上传jpg/png文件，建议研习社悬浮球尺寸：142*116px，大小不超过100K
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="展示用户" v-show="info.banner_item_id == 10">
        <el-select
            size="mini"
            v-model="info.show_user_type"
            placeholder="请选择"
            clearable
            filterable
        >
          <el-option label="全部" :value="0">全部</el-option>
          <el-option label="合伙人" :value="1">合伙人</el-option>
          <el-option label="发光者" :value="2">发光者</el-option>
          <el-option label="普通用户" :value="3">普通用户</el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Android开屏图片2" v-show="info.banner_item_id == 11">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest2"
          :before-upload="beforeImageUpload"
        >
          <img v-if="info.image_android_2" :src="info.image_android_2" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，APP android 开屏图片2：1080*2160px 大小不超过200K
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="IOS开屏图片1" v-show="info.banner_item_id == 11">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest3"
          :before-upload="beforeImageUpload"
        >
          <img v-if="info.image_ios_1" :src="info.image_ios_1" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，APP IOS 开屏图片1：1242*2688px 大小不超过200K
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="IOS开屏图片2" v-show="info.banner_item_id == 11">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest4"
          :before-upload="beforeImageUpload"
        >
          <img v-if="info.image_ios_2" :src="info.image_ios_2" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，APP IOS 开屏图片2：1242*2208px 大小不超过200K
          </div>
        </el-upload>
      </el-form-item>

      <banner-target ref="bannerTarget" :target="info.target" :address="info.address" :target_msg="info.target_msg" :target_id="info.target_id" :source_type="source_type"></banner-target>

      <el-form-item label="显示时间" required>
        <el-date-picker v-model="info.display_start_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" :disabled="type=='update' && form.status == 1"></el-date-picker> ~
        <el-date-picker v-model="info.display_end_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间" :disabled="type=='update' && form.status == 1"></el-date-picker>
      </el-form-item>

      <el-form-item label="是否一直显示" v-show="info.banner_item_id == 10">
        <el-radio-group v-model="info.is_always_display">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="createUpdate()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import { getBannerItemList,  createUpdate, getDetail } from "@/api/banner";
import bannerTarget from '../../components/bannerTarget.vue';

export default {
  components: { bannerTarget },
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      bannerItemList: [],
      source_type: 0,
      targetClientAble: false,
      info: {
        id: 0,
        title: "",
        banner_item_id: "",
        target_client: "ALL",
        image: "",
        image_android_2: "",
        image_ios_1: "",
        image_ios_2: "",
        target: '',
        target_id: 0,
        target_msg: "",
        display_start_time: "",
        display_end_time: "",
        is_always_display: 1,
        show_user_type: 0
      },

    };
  },
  created: function () {
    getBannerItemList().then((response) => {
      this.bannerItemList = response.data;
    });
    this.info.id = this.$route.query.id;
    if(this.info.id){
      this.targetClientAble = true;
    }
    if (this.info.id > 0) {
      this.getInfo();
    }
    
  },
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.image = fileUrl;
        });
      });
    },

    uploadOSSRequest2(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.image_android_2 = fileUrl;
        });
      });
    },
    uploadOSSRequest3(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.image_ios_1 = fileUrl;
        });
      });
    },
    uploadOSSRequest4(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.image_ios_2 = fileUrl;
        });
      });
    },

    getInfo() {
      this.loading = true;
      getDetail({
        id: this.info.id,
      }).then((response) => {
        this.info = response.data;
        this.info.banner_item_id = String(this.info.banner_item_id);
        this.tmpTarget = this.info.target;
        this.loading = false;
      });
    },
    createUpdate() {
      this.info.target = this.$refs.bannerTarget.theTarget;
      this.info.address = this.$refs.bannerTarget.theAddress;
      this.info.target_id = this.$refs.bannerTarget.theTargetId;
      if (this.info.target == '') {
        this.$message.error('请选择跳转目的');
        return;
      }
      if (['live_detail', 'course_detail', 'workshop_detail', 'book_detail', 'product_detail', 'course_package'].indexOf(this.info.target) >= 0) {
        if (this.info.target_id <= 0) {
          this.$message.error('请选择跳转目的');
          return;
        }
      }
      // if (this.info.target == 'target_h5') {
      //   if (this.info.address == '') {
      //     this.$message.error('请填写运营H5活动地址');
      //     return;
      //   }
      // }
      this.updateLoading = true;
      createUpdate(this.info)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/banner/list",
              query: {
                type: this.info.type
              }
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    changeBannerItem(){

    },

    ref() {
      window.history.go(-1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 423px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 335px;
  height: 143px;
  display: block;
  background: #D8D8D8;
  border-radius: 6px;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>